<script setup>
import { useAttrs } from 'vue';
import { useMapGetter } from 'dashboard/composables/store';

const attrs = useAttrs();
const globalConfig = useMapGetter('globalConfig/get');
</script>

<template>
  <img
    v-if="globalConfig.logoThumbnail"
    v-bind="attrs"
    :src="globalConfig.logoThumbnail"
    class="dark:invert"
  />
  <svg
    v-else
    v-once
    v-bind="attrs"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g transform="scale(0.03125) translate(0, -34)">
      <rect x="0" y="34" width="512" height="512" rx="256" fill="#000000" />
      <path
        d="M160 150H270C320 150 355 180 355 225C355 270 320 295 270 295H220V430H160V150ZM220 210V245H265C285 245 295 235 295 227.5C295 220 285 210 265 210H220Z"
        fill="#FFFFFF"
      />
      <path d="M250 295L335 430H395L305 295H250Z" fill="#FFFFFF" />
    </g>
  </svg>
</template>
